import { createContext, useContext } from 'react';
export const SessionInfoContext = /*#__PURE__*/createContext({
  branchId: undefined,
  esi: undefined,
  galleryInstance: undefined,
  initialData: undefined,
  isDebugMode: false,
  locale: undefined,
  msid: undefined,
  publishedBranchId: undefined,
  referral: undefined,
  setPublishedBranchId: () => {},
  shouldAutoScan: false,
  shouldQueryLatestScan: false,
  storesInstance: undefined,
  userPermissions: [],
  wizard_session_start_ts: undefined
});
export const useSessionInfoContext = () => {
  const context = useContext(SessionInfoContext);
  if (!context) {
    throw new Error('useSessionInfoContext must be used within a provider component');
  }
  return context;
};
//# sourceMappingURL=use-session-info-context.js.map